import { React, useState, useRef } from "react";
const MarketAnalysisEvenOdd = ({ eventDetails, evenodddata }) => {
  return (
    <div style={{ backgroundColor: "transparnet" }}>
      <div className="card card-accent-success">
        <div className="row bg-gray-100 market-head">
          <div className="col-12">
            <strong className="site_family">Even / Odd</strong>
          </div>
        </div>
        <div
          className="market-runners"
          style={{
            borderLeft: "solid 1px #808080",
            borderRight: "solid 1px #808080",
            borderBottom: "solid 1px #808080"
          }}
        >
          {evenodddata !== null &&
            evenodddata !== undefined &&
            evenodddata !== "" &&
            evenodddata.map((fancy) => (
              <div>
                <div className="row runners">
                  <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                    <strong
                      style={{ fontSize: "1rem" }}
                      className="site_family"
                    >
                      {fancy.market}
                    </strong>{" "}
                    <br />{" "}
                    <span>
                      <span class="position-plus site_family"></span>{" "}
                    </span>{" "}
                  </div>{" "}
                  <div class="col-5 col-md-8 price">
                    <div class="row">
                      <div class="col-md-2 d-none d-md-block cta-back">
                        <div class="col-12 price site_family"> </div>{" "}
                        <div class="col-12 size site_family"> </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-back">
                        <div class="col-md-12 col-sm-12 price site_family">
                          {" "}
                        </div>{" "}
                        <div class="col-md-12 col-sm-12 size site_family">
                          {" "}
                        </div>
                      </div>{" "}
                      <div class="col-6 col-md-2 cta-back">
                        <div
                          class="col-12 price site_family"
                          style={{ backgroundColor: "rgb(227, 248, 255)" }}
                        >
                          {fancy.back}
                        </div>{" "}
                        <div
                          id="bs1-54600"
                          class="col-12 size site_family"
                          style={{ backgroundColor: "rgb(227, 248, 255)" }}
                        >
                          {fancy.backrate}
                        </div>
                      </div>{" "}
                      <div class="col-6 col-md-2 cta-lay">
                        <div
                          class="col-md-12 col-sm-12 price site_family"
                          style={{ backgroundColor: "rgb(255, 205, 204)" }}
                        >
                          {fancy.lay}
                        </div>{" "}
                        <div
                          class="col-md-12 col-sm-12 size site_family"
                          style={{ backgroundColor: "rgb(255, 205, 204)" }}
                        >
                          {fancy.layrate}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-lay">
                        <div class="col-md-12 col-sm-12 price site_family">
                          {" "}
                        </div>{" "}
                        <div class="col-md-12 col-sm-12 size site_family">
                          {" "}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-lay">
                        <div class="col-md-12 col-sm-12 price site_family">
                          {" "}
                        </div>{" "}
                        <div class="col-md-12 col-sm-12 size site_family">
                          {" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default MarketAnalysisEvenOdd;